// @flow

import { View } from 'reshaped';

import { AlertBlock } from 'src/Reshaped/AlertBlock';

import { useButtonDisabledReason } from '../hooks/useButtonDisabledReason';

import { InfoBlock } from './InfoBlock';

export function MessagesBlock(): React.MixedElement {
  const { errorMessage, noWarning } = useButtonDisabledReason();

  return (
    <View gap={4}>
      {errorMessage && (
        <AlertBlock
          color={noWarning ? undefined : 'warning'}
          messages={[errorMessage]}
        />
      )}
      <InfoBlock />
    </View>
  );
}
